export default "__VITE_ASSET__v1coa9cK__"